namespace ui
{
	export namespace tab
	{
		export class Entry
			extends pattern.observer.Observer
		{
			private m_Element:				JQuery<HTMLElement>;
			private m_Title:					string;
			private m_Pane:						TabPane;
			private	m_Bar:						Bar;
			private m_ID:							string;
			private m_Key:						string;
			/**
			 * Icon is currently not used but planned.
			 */
			private m_Icon:						Icon|null;
			private m_Reload:					JQuery<HTMLElement>;
			private m_Close:					JQuery<HTMLElement>|null;
			private	m_Presenter:			TabHTMLPresentation;
			private m_TitleText:			ui.base.BaseHTMLElement;

			constructor(
				title: string,
				bar: Bar,
				presenter: TabHTMLPresentation,
				close: boolean,
				reload: boolean,
				AriaControlHint?: string
			)
			{
				super();

				this.m_Bar						= bar;
				this.m_ID							= this.m_Bar.ID() +
																'_' +
																(
																	Math.ceil( Math.random() * 1000000 ) + new Date().getTime()
																)
																.toString().replace( '.', '_' );
				this.m_Pane						= new TabPane( this.m_ID );
				this.m_Title					= title;
				this.m_Key						= presenter.UUID;
				this.m_Element				= ui.$$.div();
				this.m_Close					= null;
				this.m_Reload					= ui.$$.span();
				this.m_Presenter			= presenter;
				this.m_Icon						= null;
				this.m_TitleText			= new ui.base.BaseHTMLElement( 'title-text' );

				this.m_Presenter.Entry( this );

				if ( reload )
				{
					this.m_Reload.addClass( 'fas fa-sync fa-spin reload' );
				}

				if ( close )
				{
					this.m_Close	= ui.$$.span();

					this.m_Close.addClass( 'close fas fa-times' );
					this.m_Close.css(
						{
							"margin-left": "3px",
							"margin-top": "2px",
						},
					);
				}

				this.m_Element.css( 'position', 'relative' );
				this.m_Element.attr( 'data-target', '#' + this.m_ID );
				this.m_Element.attr( 'aria-controls', AriaControlHint || this.m_Title );
				this.m_Element.attr( 'role', 'tab' );
				this.m_Element.attr( 'data-toggle', 'tab' );

				this.m_Element.append( ui.$$.div().append( this.m_TitleText.append( this.m_Title ).Root() ) );

				if ( this.m_Close )
				{
					this.m_Element.append( this.m_Close );
				}
				if ( this.m_Reload )
				{
					this.m_Element.append( this.m_Reload );
				}

				this.Build();
			}

			public Title( title?: string ): string|void
			{
				if ( title )
				{
					this.m_Title = title;

					this.m_TitleText.text( title );

					return;
				}

				return this.m_Title;
			}

			public Key(): string
			{
				return this.m_Key;
			}

			public Icon(): Icon|null;
			public Icon( icon: Icon ): Entry;
			public Icon( icon?: Icon ): Icon|null|Entry
			{
				if ( icon instanceof Icon )
				{
					this.m_Icon = icon;

					return this;
				}

				return this.m_Icon;
			}

			public Build(): void
			{
				if ( this.m_Close )
				{
					this.m_Close.on( 'click', () => this.m_Bar.removeTab( this ) );
				}

				this.m_Element.on( 'click', () => this.m_Bar.notify( { type: 'show', entry: this } ) );
			}

			public ActivateReloadSpin(): void
			{
				this.m_Reload.addClass( 'fa-spin' );
				this.m_Reload.off();
			}

			public DeactivateReloadSpin(): void
			{
				this.m_Reload.removeClass( 'fa-spin' );
				this.m_Reload.on( 'click', () => this.update( { entry: this, type: 'reload' } ) );
			}

			public Pane(): TabPane
			{
				return this.m_Pane;
			}

			public Tab(): JQuery<HTMLElement>
			{
				return this.m_Element;
			}

			public update( data: NotifyInfo ): void
			{
				if ( data.entry !== this ) { return; }

				if ( data.type === 'remove' )
				{
					this.Remove();
				}
				else if ( data.type === 'hide' )
				{
					this.Hide();
				}
				else if ( data.type === 'reload' )
				{
					this.m_Presenter.reload();
				}
				else
				{
					this.Show();
				}
			}

			private Remove(): void
			{
				this.m_Element.remove();
				this.m_Pane.remove();
			}

			private Show(): void
			{
				this.m_Element.tab( 'show' );
			}

			private Hide(): void
			{
				// @ts-ignore
				this.m_Element.tab( 'hide' );
			}
		}
	}
}
